import { MutationTree } from "vuex";
import { RootState } from "@service/store/types/RootState";
import { Session } from "@service/types/Session";
import Vue from 'vue';
import {UserProfile} from "@api/models/UserProfile";

export const mutations: MutationTree<RootState> = {
    setSession(state, data: Session) {
        state.session = data;
    },
    setSessionProfile(state, data) {
        Vue.set(state.session, 'profile', data instanceof UserProfile ? data : new UserProfile(data));
    },
    setSessionLanguage(state, language) {
        Vue.set(state.session, 'language', language);
    },
    resetSession(state) {
        state.session = {
            userId: -1,
            sessionId: '',
            refreshToken: '',
            language: '',
            roleId: '',
            profile: undefined,
            backend: ''
        }
    },
    setIsLoading(state, value) {
        state.isLoading = value;
    },
    setAfterLoginPath(state, path) {
        state.afterLoginPath = path;
    },
    setOffset(state, value) {
        state.timeZoneOffset = value;
    },
    setShowChat(state, value) {
        state.showChat = value;
    },
    setTimeZoneNames(state, value) {
        Vue.set(state, 'timeZoneNames', value);
    },
    setScreenNameData(state, payload) {
        state.screenNameData = payload;
    },
    setIsTokenUpdating(state, value) {
        state.isTokenUpdating = value;
    },
    setWebConferenceRecordingEventId(state, value) {
        state.webConferenceRecordingEventId = value;
    },
    setInitializing(state, value) {
        state.initializing = value;
    },
    setInitErrors(state, value) {
        state.initErrors = value;
    },
    setCurrentUserCompanyId(state, payload) {
        state.currentUserCompanyId = payload;
    },
    setSelectedTimeZone(state, payload) {
        state.selectedTimeZoneOffset = payload;
    }
};
